import { render, staticRenderFns } from "./ConnectionsList.vue?vue&type=template&id=306bf94d&scoped=true"
import script from "./ConnectionsList.vue?vue&type=script&lang=ts"
export * from "./ConnectionsList.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionsList.vue?vue&type=style&index=0&id=306bf94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306bf94d",
  null
  
)

export default component.exports